const palette = {
  bgLight: '#f9fafb',
  bgLighter: '#f5f7f9',
  bgPale: '#fafafa',
  bgPurple: '#f6f5fb',
  black: '#000000',
  blueLight: '#eff3ff',
  borderGray: '#b5b5b5',
  borderGrayMd: '#707070',
  borderInput: '#dadde9',
  borderLight: '#e5e7eb',
  borderLightGray: '#bdbdbd',
  borderMuted: '#d1d5dc',
  borderNeutral: '#cccccc',
  caption: '#6a7282',
  checkboxGray: '#a9a9a9',
  dark: '#2e2a3a',
  darkPurple: '#3A2878',
  dashboardBg: '#f5f6f8',
  disabled: '#dbdbdb',
  divider: '#dddddd',
  error: '#e7000b',
  errorBackground: '#fef2f2',
  errorBorder: '#ffc9c9',
  errorInput: '#d4183d',
  focus: '#a3a3a3',
  gray: '#595959',
  gray50: '#f9fafb',
  gray300: '#d1d5db',
  gray700: '#374151',
  greenish: '#59b7b3',
  hairline: 'rgba(0, 0, 0, 0.1)',
  inputBg: '#f3f3f5',
  labelBlue: '#6f9ad1',
  labelGreen: '#10b981',
  labelOrange: '#dea154',
  labelPurple: '#9f83d1',
  lavender: '#e8e4fa',
  lightGray: '#e8e8e8',
  linkGreen: '#10a37f',
  mellowGray: '#acaaa5',
  placeholder: '#717182',
  primary: '#483499',
  primary20: '#48349933',
  purpleLight: '#c4b8ff',
  purpleMid: '#4a3fbf',
  scrollbarThumb: '#888888',
  scrollbarThumbHover: '#555555',
  scrollbarTrack: '#f1f1f1',
  secondary: '#6648dc',
  shadowLight: '#d5d5d5',
  success: '#1e824c',
  successIcon: '#34d399',
  successLight: '#8fd8ae',
  switch: '#b4bcce',
  tealLight: '#c6dad9',
  tealPale: '#d3e7e6',
  textBlack: '#000000',
  textBody: '#364153',
  textDark: '#101828',
  textDarkSecondary: '#0a0a0a',
  warmGray: '#5b564d',
  warning: '#b8860d',
  white: '#ffffff',
};

function toUpperHex(hex) {
  if (typeof hex !== 'string' || !hex.startsWith('#')) return hex;
  return `#${hex.slice(1).toUpperCase()}`;
}

const LegacyColors = Object.fromEntries(
  Object.entries(palette).map(([key, value]) => [key, toUpperHex(value)]),
);

/* eslint-disable no-undef */
module.exports = { palette, LegacyColors };
/* eslint-enable no-undef */
